import React, { FC } from 'react'
import { useScroll } from 'Pages/landings/newLandings/common/hooks'
import { MenuLogoIcon } from './Icon'
import { Wrapper, Button, FixedWrapper } from './styled'

interface ComponentProps {
	buttonType?: string
	buttonScrollTo?: string
	buttonText?: string
	className?: string
}

export const MenuComponent: FC<ComponentProps> = ({
	className,
	buttonScrollTo = '',
	buttonType = 'primary',
	buttonText = 'Подать заявку',
}) => {
	const { scrollIntoBlock } = useScroll()
	return (
		<FixedWrapper>
			<Wrapper>
				<MenuLogoIcon />
				{buttonScrollTo && (
					<Button
						type={buttonType}
						measure="m"
						text={buttonText}
						onClick={() => scrollIntoBlock(`#${buttonScrollTo}`)}
						className={className}
					/>
				)}
			</Wrapper>
		</FixedWrapper>
	)
}
